<template>
  <el-dialog
    title="优惠券池"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card header-class="flex justify-between">
          <el-row :gutter="20">
            <el-col :span="18"></el-col>
            <el-col :span="6">
              <el-input-group>
                <el-input
                  v-model="chooseCouponPoolInfo._currentCouponPoolName"
                  placeholder="输入优惠券池名称"
                ></el-input>
                <el-button
                  slot="append"
                  type="primary"
                  @click="queryCouponPools"
                >查询</el-button>
              </el-input-group>
            </el-col>
          </el-row>

          <el-table
            :data="chooseCouponPoolInfo.couponPools"
            style="width: 100%;margin-top:15px"
            border
            stripe
          >
            <el-table-column prop="poolId" label="优惠券池编码" align="center"></el-table-column>
            <el-table-column prop="couponTypeName" label="优惠券类型" align="center"></el-table-column>
            <el-table-column prop="couponName" label="优惠券名称" align="center"></el-table-column>
            <el-table-column prop="actualPrice" label="面值" align="center"></el-table-column>
            <el-table-column prop="buyPrice" label="购买价格" align="center"></el-table-column>
            <el-table-column prop="couponStock" label="数量" align="center"></el-table-column>
            <el-table-column prop="validityDay" label="有效期" align="center"></el-table-column>
            <el-table-column prop="state" label="状态" align="center">
              <template slot-scope="scope">
                {{ scope.row.state == '2002' ? '上架' : '停售' }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="chooseCouponPool(scope.row)"
                >选择</el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
            class="pagination"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listCouponPool } from '@/api/goods/couponShopPoolApi'

export default {
  name: 'ChooseCouponPool',
  data() {
    return {
      dialogVisible: false,
      chooseCouponPoolInfo: {
        couponPools: [],
        _currentCouponPoolName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshChooseCouponPoolInfo()
      this._loadAllCouponPoolInfo()
    },
    handleClose() {
      this.chooseCouponPoolInfo._currentCouponPoolName = ''
    },
    async _loadAllCouponPoolInfo() {
      const params = {
        page: this.currentPage,
        row: this.pageSize,
        state: '2002',
        name: this.chooseCouponPoolInfo._currentCouponPoolName
      }
      try {
        const res = await listCouponPool(params)
        this.chooseCouponPoolInfo.couponPools = res.data
        this.total = res.records
      } catch (error) {
        console.error(error)
      }
    },
    chooseCouponPool(couponPool) {
      if (Object.prototype.hasOwnProperty.call(couponPool,'name')) {
        couponPool.couponPoolName = couponPool.name
      }
      this.$emit('choose', couponPool)
      this.dialogVisible = false
    },
    queryCouponPools() {
      this.currentPage = 1
      this._loadAllCouponPoolInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._loadAllCouponPoolInfo()
    },
    _refreshChooseCouponPoolInfo() {
      this.chooseCouponPoolInfo._currentCouponPoolName = ""
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: right;
}
</style>